/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { computeSelection } from "../selection.js";
import { errorNoInspect } from "../operations/error.js";
export { IsolateSelectionTransform };
class IsolateSelectionTransform {
    #nodes;
    #graphId;
    constructor(nodes, graphId) {
        this.#nodes = nodes;
        this.#graphId = graphId;
    }
    async apply(context) {
        const { mutable } = context;
        const inspector = mutable.graphs.get(this.#graphId);
        if (!inspector) {
            return errorNoInspect(this.#graphId);
        }
        const selection = computeSelection(inspector, this.#nodes);
        if (!selection.success) {
            return selection;
        }
        const { dangling } = selection;
        const edits = dangling.map((edge) => ({
            type: "removeedge",
            edge,
            graphId: this.#graphId,
        }));
        const result = await context.apply(edits, "Isolating Selection");
        if (!result.success) {
            return result;
        }
        return { success: true };
    }
}
//# sourceMappingURL=isolate-selection.js.map